var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"address",on:{"click":function($event){return _vm.showPopup()}}},[_c('div',{staticClass:"city"},[_vm._v(_vm._s(_vm.city))]),_c('div',{staticClass:"pull-down"},[_c('van-icon',{attrs:{"name":"arrow-down","size":"13px"}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }